import { gql } from '@apollo/client';

export const CLIENT_LIST = gql`
  query ClientList($applicationId: Int, $clientId: String) {
    clientList(applicationId: $applicationId, clientId: $clientId) {
      id
      clientName
      logoPath
    }
  }
`;

export const HR_FIELD_ALIASES_QUERY = gql`
  query HrFieldAliases($clientId: String!) {
    hrFieldAliases(clientId: $clientId) {
      fieldName
      fieldAlias
    }
  }
`;

export const QUERY_HR_FIELDS_VALUES = gql`
  query HrFieldValues($clientId: String!, $fieldName: String!, $searchString: String!) {
    hrFieldValues(clientId: $clientId, fieldName: $fieldName, searchString: $searchString)
  }
`;

export const CONSOLIDATED_SPEND_BREAKDOWN_DIMENSIONS_QUERY = gql`
  query ConsolidatedSpendBreakdownDimensions($clientId: String!) {
    consolidatedSpendBreakdownDimensions(clientId: $clientId) {
      dimensionName
      displayName
    }
  }
`;